import { useTimezoneParam } from '@features/date-time';
import { useFilter } from '@features/table-filter';

import { useGetTokenSalesQuery } from '../api';
import type { ITokenSaleFilter } from '../model/types';

interface IProps {
  disableUrlFilter?: boolean;
}

export const useTokenSales = ({ disableUrlFilter }: IProps = {}) => {
  const filter = useFilter<ITokenSaleFilter>({ disableUrlFilter });
  const { currentFilter, updateFilter } = filter;

  useTimezoneParam({ currentFilter, updateFilter });

  const {
    data: tokenSales,
    isLoading,
    isError,
    error,
    isFetching,
    isSuccess,
    refetch,
  } = useGetTokenSalesQuery(currentFilter.toString());

  return {
    tokenSales,
    isError,
    error,
    isLoading,
    isFetching,
    isSuccess,
    refetch,

    filter,
  };
};
